"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCardButton = void 0;
var _CardButton = require("./CardButton");
// TODO: in v9, move styled() from CardButton.jsx to here
var StyledCardButton = _CardButton.CardButton;
exports.StyledCardButton = StyledCardButton;